import { FormControl, Textarea } from '@mui/joy';
import { Controller } from 'react-hook-form';

import { FormError, FormLabel } from 'core/elements';
import { parseString } from 'core/utils';
import { toFieldFocusRef } from 'core/utils/fieldFocus';

import { IProps } from './Textarea';

const TextareaWithControllerView = ({
  control,
  error,
  name,
  label,
  tooltip,
  required = false,
  defaultValue,
  onChange,
  placeholder = '',
  slotProps,
  disabled = false,
  size,
  showFieldError = false,
  ...rest
}: IProps) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { ref, ...field } }) => {
        return (
          <FormControl error={Boolean(error)} size={size}>
            {label && (
              <FormLabel required={required} tooltip={tooltip}>
                {label}
              </FormLabel>
            )}

            <Textarea
              {...field}
              {...rest}
              value={parseString(field?.value || '').toString()}
              onChange={(e) => {
                field.onChange(e);
                onChange && onChange(e);
              }}
              placeholder={placeholder}
              slotProps={{
                ...slotProps,
                textarea: { ...slotProps?.textarea, ref: toFieldFocusRef(ref) },
              }}
              disabled={disabled}
              size={size}
            />

            {showFieldError && error && <FormError error={error} />}
          </FormControl>
        );
      }}
    />
  );
};

export default TextareaWithControllerView;
